import React from "react";
import RelativeContainer from "../containers/RelativeContainer";

const PageContainer = ({ minHeight, width, children }) => {
  return (
    <RelativeContainer
      style={{
        width,
        height: "auto",
        justifyContent: "flex-start",
        minHeight,
      }}
    >
      {children}
    </RelativeContainer>
  );
};

export default PageContainer;
